import axios from 'axios';

const wbsService = axios.create({
  baseURL: process.env.REACT_APP_API_WBS_SURVEY,
  timeout: 20000
});

export { wbsService };
